import _get from "lodash/get";
import styled from 'styled-components';
import { rem } from 'polished';
import siteLaunchTheme from '../../../styles/siteLaunchTheme';
var CallToActions = styled.div.withConfig({
  displayName: "CallToActions",
  componentId: "sc-15tgau-0"
})(["align-items:center;display:flex;flex-flow:row wrap;justify-content:flex-start;padding:", " 0;margin:0 -", ";"], function (_ref) {
  var theme = _ref.theme;
  return rem(_get(theme, 'siteLaunch.callToActions.paddingV', siteLaunchTheme.siteLaunch.callToActions.paddingV));
}, function (_ref2) {
  var theme = _ref2.theme;
  return rem(_get(theme, 'siteLaunch.callToActions.callToAction.paddingH', siteLaunchTheme.siteLaunch.callToActions.callToAction.paddingH));
});
export default CallToActions;